module.exports = __webpack_public_path__ + "img/4s.c6fdd09b.png";